import React, { forwardRef, SVGProps } from 'react';

export const GreenCheckIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { css?: any }
>((props, ref) => (
  <svg
    ref={ref}
    width={props?.width || '34'}
    height={props?.height || '24'}
    viewBox="0 0 29 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 15C26.3137 15 29 12.3137 29 9C29 5.68629 26.3137 3 23 3C19.6863 3 17 5.68629 17 9C17 12.3137 19.6863 15 23 15ZM22.16 6.53672C22.16 6.07461 22.5346 5.7 22.9967 5.7H23.0033C23.4654 5.7 23.84 6.07461 23.84 6.53672C23.84 6.99883 23.4654 7.37344 23.0033 7.37344H22.9967C22.5346 7.37344 22.16 6.99883 22.16 6.53672ZM22.16 9.16172C22.16 8.69961 22.5346 8.325 22.9967 8.325C23.4588 8.325 23.8334 8.69961 23.8334 9.16172V11.7867C23.8334 12.2488 23.4588 12.6234 22.9967 12.6234C22.5346 12.6234 22.16 12.2488 22.16 11.7867V9.16172Z"
      fill="#D9DADE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C12.3957 18 15.3521 16.1195 16.8847 13.343C16.0128 12.1175 15.5 10.6186 15.5 9C15.5 7.38138 16.0128 5.88252 16.8847 4.65698C15.3521 1.88054 12.3957 0 9 0ZM13.075 7.50042L8.52441 12.1564C8.30974 12.3764 8.01843 12.5 7.71467 12.5C7.4109 12.5 7.1196 12.3764 6.90492 12.1564L4.8345 10.0405C4.38761 9.58169 4.38863 8.83894 4.83679 8.38146C5.28495 7.92399 6.01053 7.92504 6.45742 8.38381L7.71638 9.67257L11.4521 5.84493C11.8987 5.38617 12.624 5.38486 13.0721 5.84201C13.5203 6.29915 13.5216 7.04165 13.075 7.50042Z"
      fill="#12DE9A"
    />
  </svg>
));
